<div
  class="grid grid-flow-col transition-all duration-300"
  [class.grid-cols-[minmax(0,auto)_minmax(0,1fr)_350px]]="
    summaryPanelRef.expanded() && shouldShowSummaryPanel()
  "
  [class.grid-cols-[minmax(0,auto)_minmax(0,1fr)_56px]]="
    !summaryPanelRef.expanded() && shouldShowSummaryPanel()
  "
  [class.grid-cols-[minmax(0,auto)_minmax(0,1fr)]]="!shouldShowSummaryPanel()"
>
  <div class="relative z-[1]">
    <ri-resolution-ui-sidebar #sidebarRef></ri-resolution-ui-sidebar>
  </div>
  <div class="relative">
    <ng-container *ngTemplateOutlet="overlay"></ng-container>
    <router-outlet></router-outlet>
  </div>
  <div [class.hidden]="!shouldShowSummaryPanel()" class="relative">
    <ng-container *ngTemplateOutlet="overlay"></ng-container>
    <ri-resolution-ui-summary-panel
      [summary]="rightPanelSummaryData()"
      [defaultExpanded]="defaultExpandSummaryPanel()"
      #summaryPanelRef
    ></ri-resolution-ui-summary-panel>
  </div>
</div>
<ng-template #overlay>
  <div
    [class]="
      showOverlay()
        ? 'absolute inset-0 z-20 bg-gray-500/5 backdrop-blur-sm'
        : ''
    "
  ></div>
</ng-template>
